import React from "react";
import {
  ShieldCheck, UserCheck, Megaphone, LayoutDashboard,
  Landmark, GraduationCap, TrendingUp, Building2, ArrowRight,
} from "lucide-react";
import { Btn } from "./ui";
import { LINKS } from "./data";

const AGENT_IMG = "https://images.pexels.com/photos/8730012/pexels-photo-8730012.jpeg";

const CARDS = [
  { icon: ShieldCheck, title: "Broker-Led Support" },
  { icon: UserCheck, title: "Agent-First Model" },
  { icon: Megaphone, title: "Marketing & Lead Generation" },
  { icon: LayoutDashboard, title: "Modern Agent Portal & Tools" },
  { icon: Landmark, title: "Real Estate & Mortgage Guidance" },
  { icon: GraduationCap, title: "Training & Mentorship" },
  { icon: TrendingUp, title: "Growth-Focused Culture" },
  { icon: Building2, title: "Southern California Brand Presence" },
];

export const RecruitingSection = () => (
  <section id="join" className="py-20 lg:py-28 bg-[#254369] relative overflow-hidden">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
      <div className="grid lg:grid-cols-2 gap-12 items-center">
        <div>
          <p className="text-[#C9A961] font-heading font-bold uppercase tracking-[0.18em] text-xs mb-4">
            Careers · Join The Team
          </p>
          <h2 className="font-heading font-extrabold tracking-tight text-3xl sm:text-4xl lg:text-[2.75rem] leading-[1.1] text-white">
            Build Your Real Estate Business With Wallstreet Realty
          </h2>
          <p className="mt-6 text-base sm:text-lg leading-relaxed text-white/80 max-w-xl">
            Wallstreet Realty is built for licensed agents who want broker support, mentorship,
            marketing tools, technology, lead systems, and a growth-focused brokerage environment.
          </p>
          <div className="mt-8 flex flex-wrap gap-3">
            <Btn href={LINKS.join} variant="gold" testid="recruit-apply">
              Apply to Join Wallstreet Realty <ArrowRight size={16} />
            </Btn>
            <Btn href={LINKS.join} variant="outlineLight" testid="recruit-book-call">
              Book an Agent Recruiting Call
            </Btn>
          </div>
        </div>
        <div className="hidden lg:block">
          <img
            src={AGENT_IMG}
            alt="Real estate professionals collaborating"
            className="w-full h-[420px] object-cover rounded-[20px] shadow-2xl"
            loading="lazy"
          />
        </div>
      </div>

      <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {CARDS.map((c) => (
          <div
            key={c.title}
            data-testid={`recruit-card-${c.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}
            className="lift bg-white/[0.06] border border-white/10 rounded-[20px] p-6 hover:bg-white/[0.1]"
          >
            <div className="w-11 h-11 rounded-xl bg-[#C9A961]/20 flex items-center justify-center mb-4">
              <c.icon className="text-[#C9A961]" size={20} />
            </div>
            <h3 className="font-heading font-bold text-white text-[15px] leading-snug">{c.title}</h3>
          </div>
        ))}
      </div>
    </div>
  </section>
);
